import { Warning } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import ComparadorEmentaDecisao from '@/components/ComparadorEmentaDecisao';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/certidao.css';
import ReactComponent from '../ReactComponent';

// prettier-ignore
export const TIPO_TEXTO = {
    EMENTA:  { id: 'EMENTA',  descricao: 'Ementa'  },
    DECISAO: { id: 'DECISAO', descricao: 'Decisão' }
};

const KeyframesBlinkBotaoExibirEmentaDecisaoMinutaVoto = styled('span')({
    '@keyframes blink': {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0.3
        }
    },
    animation: 'blink 1s',
    animationIterationCount: 'infinite'
});

class AlertaInconsistenciaEmentaDecisao extends ReactComponent {
    open = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            open: observable,
            abrirPopupEmentaDecisao: action,
            fecharPopupEmentaDecisao: action
        });
    }

    componentDidMount() {}

    abrirPopupEmentaDecisao = () => {
        this.open = true;
    };

    fecharPopupEmentaDecisao = () => {
        this.open = false;
    };

    get registro() {
        return this.observableProps.registro;
    }

    render() {
        if (!this.isComponenteHabilitado('PlanilhaPlenario') || !this.registro.ementaDecisaoVoto) {
            return null;
        }

        let exibirComparacaoEmenta = false;
        let exibirComparacaoDecisao = false;

        if (this.observableProps.tipoTexto.id === TIPO_TEXTO.DECISAO.id && this.registro.ementaDecisaoVoto.decisao) {
            exibirComparacaoDecisao = true;
        } else if (
            this.observableProps.tipoTexto.id === TIPO_TEXTO.EMENTA.id &&
            this.registro.ementaDecisaoVoto.ementa
        ) {
            exibirComparacaoEmenta = true;
        }

        if (!exibirComparacaoDecisao && !exibirComparacaoEmenta) {
            return <></>;
        }

        const textoTooltip = `${this.observableProps.tipoTexto.descricao} da minuta de voto está diferente do conteúdo do campo "${this.observableProps.tipoTexto.descricao}"`;

        return (
            <>
                <Tooltip
                    title={textoTooltip}
                    placement="top-start"
                >
                    <KeyframesBlinkBotaoExibirEmentaDecisaoMinutaVoto>
                        <Warning
                            className="icone icone-alerta"
                            onClick={this.abrirPopupEmentaDecisao}
                            style={{ paddingLeft: '4px', paddingTop: '8px', cursor: 'pointer' }}
                        />
                    </KeyframesBlinkBotaoExibirEmentaDecisaoMinutaVoto>
                </Tooltip>
                <ComparadorEmentaDecisao
                    open={this.open}
                    onClose={this.fecharPopupEmentaDecisao}
                    registro={this.registro}
                    exibirComparacaoEmenta={true}
                    exibirComparacaoDecisao={true}
                    exibirAnotacaoGabinete={true}
                    exibirQtdPartes={true}
                />
            </>
        );
    }
}

export default inject('stores')(observer(AlertaInconsistenciaEmentaDecisao));
